import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store, { persistor, history } from './store/configureStore';
import { PersistGate } from 'redux-persist/es/integration/react';
import appEventHandler, { AppEvents } from './modules/storeMountCheck';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import SentryContainer from './components/Sentry';
import withTracker from './modules/withTracker';
import TagManager from 'react-gtm-module';

import Loading from './components/Loading';

import Container from './containers/container';
import Loadable from 'react-loadable';

import 'bootstrap/dist/css/bootstrap.min.css';

import './style.css';
import './common.css';

import config from '../package.json';
const tagManagerArgs = {
  gtmId: config.GTM,
};

TagManager.initialize(tagManagerArgs);

const Index = Loadable({
  loader: () => import('./containers/index'),
  loading: Loading,
});
const Login = Loadable({
  loader: () => import('./containers/auth/login'),
  loading: Loading,
});
const FromCordova = Loadable({
  loader: () => import('./containers/from-corodva'),
  loading: Loading,
});
const MypageRouter = Loadable({
  loader: () => import('./containers/mypage/router'),
  loading: Loading,
});
const RegistRouter = Loadable({
  loader: () => import('./containers/regist/router'),
  loading: Loading,
});
const OrderRouter = Loadable({
  loader: () => import('./containers/order/router'),
  loading: Loading,
});
const ExamRouter = Loadable({
  loader: () => import('./containers/exam/router'),
  loading: Loading,
});
const MovieRouter = Loadable({
  loader: () => import('./containers/movie/router'),
  loading: Loading,
});
const OtherRouter = Loadable({
  loader: () => import('./containers/other/router'),
  loading: Loading,
});
const StandardRouter = Loadable({
  loader: () => import('./containers/standard/router'),
  loading: Loading,
});
const ResolveRouter = Loadable({
  loader: () => import('./containers/resolve/router'),
  loading: Loading,
});
const NoLoginRouter = Loadable({
  loader: () => import('./containers/nologin/router'),
  loading: Loading,
});
const FoucsModeRouter = Loadable({
  loader: () => import('./containers/focusmode/router'),
  loading: Loading,
});
const TokenAuth = Loadable({
  loader: () => import('./containers/token_auth'),
  loading: Loading,
});
const NotFound = Loadable({
  loader: () => import('./containers/notfound'),
  loading: Loading,
});

window.config = config;

class App extends Component {
  constructor() {
    super();
    this.state = { rehydratedFlag: false };
  }
  setRehydratedFlag() {
    this.setState({ rehydratedFlag: true });
  }
  componentDidMount() {
    appEventHandler.on(AppEvents.FINISH_REHYDRATE_STORE, () =>
      this.setRehydratedFlag()
    );
    Index.preload();
    Login.preload();
    MypageRouter.preload();
    OtherRouter.preload();
    RegistRouter.preload();
    OrderRouter.preload();
    ExamRouter.preload();
    MovieRouter.preload();
    StandardRouter.preload();
    ResolveRouter.preload();
    NoLoginRouter.preload();
    FoucsModeRouter.preload();
    TokenAuth.preload();
    NotFound.preload();
  }

  componentWillUnmount() {
    appEventHandler.removeListener(AppEvents.FINISH_REHYDRATE_STORE, () =>
      this.setRehydratedFlag()
    );
  }
  onBeforeLift() {}

  render() {
    if (process.env.NODE_ENV === 'production') {
      return (
        <SentryContainer>
          <Provider store={store}>
            <PersistGate
              loading={<Loading />}
              onBeforeLift={this.onBeforeLift}
              persistor={persistor}
            >
              <ConnectedRouter history={history}>
                <Switch>
                  <Container>
                    <Switch>
                      <Route exact path="/" component={withTracker(Index)} />
                      <Route
                        path="*/index.html"
                        component={withTracker(FromCordova)}
                      />
                      <Route
                        exact
                        path="/login"
                        component={withTracker(Login)}
                      />
                      <Route
                        path="/other"
                        component={withTracker(OtherRouter)}
                      />
                      <Route
                        path="/order"
                        component={withTracker(OrderRouter)}
                      />
                      <Route path="/exam" component={withTracker(ExamRouter)} />
                      <Route
                        path="/movie"
                        component={withTracker(MovieRouter)}
                      />
                      <Route
                        path="/standard"
                        component={withTracker(StandardRouter)}
                      />
                      <Route
                        path="/resolve"
                        component={withTracker(ResolveRouter)}
                      />
                      <Route path="/focusmode" component={FoucsModeRouter} />
                      <Route
                        path="/mypage"
                        component={withTracker(MypageRouter)}
                      />
                      <Route
                        path="/regist"
                        component={withTracker(RegistRouter)}
                      />
                      <Route
                        path="/nologin"
                        component={withTracker(NoLoginRouter)}
                      />
                      <Route path="/auth/:path/:token" component={TokenAuth} />
                      <Route path="/auth/:token" component={TokenAuth} />
                      <Route component={withTracker(NotFound)} />
                    </Switch>
                  </Container>
                </Switch>
              </ConnectedRouter>
            </PersistGate>
          </Provider>
        </SentryContainer>
      );
    } else {
      return (
        <Provider store={store}>
          <PersistGate
            loading={<Loading />}
            onBeforeLift={this.onBeforeLift}
            persistor={persistor}
          >
            <ConnectedRouter history={history}>
              <Switch>
                <Container>
                  <Switch>
                    <Route exact path="/" component={withTracker(Index)} />
                    <Route
                      path="*/index.html"
                      component={withTracker(FromCordova)}
                    />
                    <Route exact path="/login" component={withTracker(Login)} />
                    <Route path="/other" component={withTracker(OtherRouter)} />
                    <Route path="/order" component={withTracker(OrderRouter)} />
                    <Route path="/exam" component={withTracker(ExamRouter)} />
                    <Route path="/movie" component={withTracker(MovieRouter)} />
                    <Route
                      path="/standard"
                      component={withTracker(StandardRouter)}
                    />
                    <Route
                      path="/resolve"
                      component={withTracker(ResolveRouter)}
                    />

                    <Route path="/focusmode" component={FoucsModeRouter} />
                    <Route
                      path="/mypage"
                      component={withTracker(MypageRouter)}
                    />
                    <Route
                      path="/regist"
                      component={withTracker(RegistRouter)}
                    />
                    <Route
                      path="/nologin"
                      component={withTracker(NoLoginRouter)}
                    />
                    <Route path="/auth/:path/:token" component={TokenAuth} />
                    <Route path="/auth/:token" component={TokenAuth} />
                    <Route component={withTracker(NotFound)} />
                  </Switch>
                </Container>
              </Switch>
            </ConnectedRouter>
          </PersistGate>
        </Provider>
      );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js